import ApiService from '../api'

class UserService {
  async getUsers(params = {}) {
    try {
      return await ApiService.get('/users', params)
    } catch (error) {
      console.error('Users not found:', error)
      throw error
    }
  }

  async createFellow(fellowData) {
    try {
      return await ApiService.post('/users/fellows', {}, fellowData)
    } catch (error) {
      console.error('Create fellow error:', error)
      throw error
    }
  }

  async updateUser(userId, userData) {
    try {
      return await ApiService.put(`/users/${userId}`, {}, userData)
    } catch (error) {
      console.error('Update user error:', error)
      throw error
    }
  }

  async deleteUser(userId) {
    try {
      return await ApiService.delete(`/users/${userId}`)
    } catch (error) {
      console.error('Delete user error:', error)
      throw error
    }
  }

  async restoreUser(userId) {
    try {
      return await ApiService.post(`/users/${userId}/restore`)
    } catch (error) {
      console.error('Restore user error:', error)
      throw error
    }
  }

  async getUser(userId) {
    try {
      return await ApiService.get(`/users/${userId}`)
    } catch (error) {
      console.error('Get user error:', error)
      throw error
    }
  }

  async getMe(userId) {
    try {
      return await ApiService.get(`/users/${userId}`)
    } catch (error) {
      console.error('Get user error:', error)
      throw error
    }
  }

  async sendPasswordReset(email) {
    try {
      console.log('Sending email: ', email)
      return await ApiService.post('/users/password-reset', {}, { email })
    } catch (error) {
      console.error('Send password reset error:', error)
      throw error
    }
  }

  async assignRole(userId, roleData) {
    try {
      return await ApiService.post(`/users/${userId}/assign-role`, {}, roleData)
    } catch (error) {
      console.error('Assign role error:', error)
      throw error
    }
  }

  async getUserRoles() {
    try {
      return await ApiService.get('/roles')
    } catch (error) {
      console.error('Get user roles error:', error)
      throw error
    }
  }

  // FIXED: Use correct endpoint path
  async getImpersonationStatus() {
    try {
      const response = await ApiService.get('/users/impersonation/status')

      // Handle different response structures
      if (response?.Data?.status === 'success') {
        return {
          status: 'success',
          data: response.Data.data
        }
      } else if (response?.status === 'success') {
        return response
      }

      throw new Error('Invalid response structure')
    } catch (error) {
      console.error('Get impersonation status error:', error)
      throw error
    }
  }

  async uploadAvatar(userId, file) {
    try {
      return await ApiService.uploadAvatar(`/users/${userId}/avatar`, file)
    } catch (error) {
      console.error('UserService: Avatar upload error:', error)
      throw error
    }
  }

  async uploadAvatarBase64(userId, base64DataUrl) {
    try {
      return await ApiService.uploadAvatarBase64(`/users/${userId}/avatar`, base64DataUrl)
    } catch (error) {
      console.error('UserService: Avatar base64 upload error:', error)
      throw error
    }
  }

  async startImpersonation(userId, reason = '') {
    try {
      const response = await ApiService.post(`/users/${userId}/impersonate`, {}, { reason })

      // Handle different response structures
      if (response?.Data?.status === 'success') {
        return {
          status: 'success',
          data: response.Data.data,
          message: response.Data.message
        }
      } else if (response?.status === 'success') {
        return response
      }

      throw new Error('Invalid response structure')
    } catch (error) {
      console.error('Start impersonation error:', error)
      throw error
    }
  }

  // FIXED: Use correct endpoint path
  async stopImpersonation() {
    try {
      const response = await ApiService.post('/users/impersonation/stop', {}, {})

      // Handle different response structures
      if (response?.Data?.status === 'success') {
        return {
          status: 'success',
          data: response.Data.data,
          message: response.Data.message
        }
      } else if (response?.status === 'success') {
        return response
      }

      throw new Error('Invalid response structure')
    } catch (error) {
      console.error('Stop impersonation error:', error)
      throw error
    }
  }

  async assignWorkingGroups(userId, workingGroupData) {
    try {
      return await ApiService.post(`/users/${userId}/assign-working-groups`, {}, workingGroupData)
    } catch (error) {
      console.error('Assign working groups error:', error)
      throw error
    }
  }

  async getAuditLogs(params = {}) {
    try {
      return await ApiService.get('/users/audit-logs', params)
    } catch (error) {
      console.error('Get audit logs error:', error)
      throw error
    }
  }

  async exportAuditLogs(params = {}) {
    try {
      return await ApiService.get('/users/audit-logs/export', params, {
        responseType: 'blob'
      })
    } catch (error) {
      console.error('Export audit logs error:', error)
      throw error
    }
  }

  async getCurrentUser() {
    return await ApiService.get('/auth/user') // Use the correct endpoint from your routes
  }

  async getCurrentAuthenticatedUser() {
    try {
      const response = await ApiService.get('/auth/user')

      if (response?.Data?.status === 'success' && response?.Data?.data) {
        return {
          status: 'success',
          data: response.Data.data,
          message: response.Data.message
        }
      }

      if (response?.status === 'success' && response?.data) {
        return response
      }

      if (response?.Data?.data?.user) {
        return {
          status: 'success',
          data: response.Data.data
        }
      }

      throw new Error(response?.Data?.message || 'Invalid response structure')
    } catch (error) {
      console.error('Get current authenticated user error:', error)
      throw error
    }
  }

  async getUsersWithFellowshipData(params = {}) {
    try {
      return await ApiService.get('/users/fellowship-data', params)
    } catch (error) {
      console.error('Users with fellowship data not found:', error)
      throw error
    }
  }

  async getFeaturedFellows() {
    try {
      return await ApiService.get('/users/featured-fellows')
    } catch (error) {
      console.error('Users with fellowship data not found:', error)
      throw error
    }
  }


  async updateProfile(profileData) {
    try {
      const response = await ApiService.post('/my-profile', {}, profileData)

      // Normalize the response structure
      if (response && response.Data) {
        return {
          success: response.Data.success || response.Success,
          message: response.Data.message || response.Message,
          data: response.Data.data,
          _originalResponse: response
        }
      }

      return response
    } catch (error) {
      console.error('Update profile error:', error)
      throw error
    }
  }
}

export default new UserService()
